import requestv2 from "~/utils/http-v2";

const reportApi = {
	revenue : async (params) => {
		const url = 'v2/report/revenue';
		return await requestv2.get(url, {params});
	},
	contract : async (params) => {
		const url = 'v2/report/contract';
		return await requestv2.get(url, {params});
	},
	financial : async (params) => {
		const url = 'v2/report/financial';
		return await requestv2.get(url, {params});
	},
	extend : async (params) => {
		const url = 'v2/report/extend';
		return await requestv2.get(url, {params});
	},
	pay : async (params) => {
		const url = 'v2/report/pay';
		return await requestv2.get(url, {params});
	},
	point : async (params) => {
		const url = 'v2/report/point';
		return await requestv2.get(url, {params});
	},
	website : async (params) => {
		const url = 'v2/report/website';
		return await requestv2.get(url, {params});
	},
	saleEvent : async (params) => {
		const url = 'v2/report/sale/event';
		return await requestv2.get(url, {params});
	},
	saleAnalytic : async (params) => {
		const url = 'v2/report/sale/analytic';
		return await requestv2.get(url, {params});
	},
	salePoint : async (params) => {
		const url = 'v2/report/sale/point';
		return await requestv2.get(url, {params});
	},
	saleCommit : async (params) => {
		const url = 'v2/report/sale/commit';
		return await requestv2.get(url, {params});
	},
	saleCallSource : async (params) => {
		const url = 'v2/report/sale/call-source';
		return await requestv2.get(url, {params});
	},
	saleStaffSummary : async (params) => {
		const url = 'v2/report/sale/staff-summary';
		return await requestv2.get(url, {params});
	},
	saleStaffSummaryDetail : async (params) => {
		const url = 'v2/report/sale/staff-summary/detail';
		return await requestv2.get(url, {params});
	},
	debt : async (params) => {
		const url = 'v2/report/debt';
		return await requestv2.get(url, {params});
	},
	contractRanks : async (params) => {
		const url = 'v2/report/contract/ranks';
		return await requestv2.get(url, {params});
	},
	training : async (params) => {
		const url = 'v2/report/training';
		return await requestv2.get(url, {params});
	},
};

export default reportApi;